
const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* ロゴとメッセージ */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
              <span className="text-transparent bg-gradient-to-r from-red-400 via-yellow-400 via-green-400 via-blue-400 via-indigo-400 via-purple-400 to-pink-400 bg-clip-text">
                ナナイロ
              </span>
            </h3>
            <p className="text-gray-300 text-sm">
              スロット演者事業として<br />
              パチンコ・スロット業界を<br />
              盛り上げる活動を行っています。
            </p>
          </div>

          {/* クイックリンク */}
          <div>
            <h4 className="font-bold mb-4 text-red-400">クイックリンク</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#schedule" className="text-gray-300 hover:text-white transition-colors">来店スケジュール</a></li>
              <li><a href="#profile" className="text-gray-300 hover:text-white transition-colors">プロフィール</a></li>
            </ul>
          </div>

          {/* ソーシャルメディア */}
          <div>
            <h4 className="font-bold mb-4 text-red-400">フォローする</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors">
                <i className="ri-tiktok-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <hr className="border-gray-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-4 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">プライバシーポリシー</a>
            <a href="#" className="hover:text-white transition-colors">求人</a>
            <a href="#contact" className="hover:text-white transition-colors">お問い合わせ</a>
          </div>
          <p className="text-sm text-gray-400 mt-4 md:mt-0">
            © 2024 ナナイロ. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
